<template>
  <div>
    <div style="margin-left: 1100px">
      <el-button type="success" @click="returns">返回</el-button>
    </div>
    <div id="main" class="echarts"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import axios from "axios";

export default {
  name: "AllEquTable",
  data() {
    return {
      option: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['Time', '电表读数', '功率', '箱体温度', '回水温度','供水温度','节能率','实时频率']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          formatter: function (value) {
            // 这里假设时间格式是 'YYYY-MM-DD HH:mm:ss' ，可以根据实际情况调整
            return value.split('.')[0];
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          // {
          //   name: '电表读数',
          //   type: 'line',
          //   stack: 'Total',
          //   data: []
          // },
          {
            name: '功率',
            type: 'line',
            // stack: 'Total',
            data: []
          },
          {
            name: '箱体温度',
            type: 'line',
            // stack: 'Total',
            data: []
          },
          {
            name: '回水温度',
            type: 'line',
            // stack: 'Total',
            data: []
          },
          {
            name: '供水温度',
            type: 'line',
            // stack: 'Total',
            data: []
          },
          {
            name: '节能率',
            type: 'line',
            // stack: 'Total',
            data: []
          },
          {
            name: 'Time',
            type: 'line',
            // stack: 'Total',
            data: []
          },
          {
            name: '实时频率',
            type: 'line',
            // stack: 'Total',
            data: []
          }
        ]
      }
    }
  },
  mounted() {
    console.log('组件已挂载');
    // 在组件挂载后初始化 ECharts 图表
    const chartDom = document.getElementById('main');
    const myChart = echarts.init(chartDom);
    if (this.option) {
      myChart.setOption(this.option);
    }
    this.echart();
  },
  methods:{
    returns(){
      const equ_id = this.$route.query.equ_id;
      const company = this.$route.query.company;
      const equ_name = this.$route.query.equ_name;
      this.$router.push({
        path:'/menu/allEquEnergy', // 路径
        query:{
          equ_id : equ_id,
          company : company,
          equ_name : equ_name
        }, //查询参数
      })
    },
    echart(){
      // 获取上一页面传递的 equ_id
      const equ_id = this.$route.query.equ_id;
      const company = this.$route.query.company;
      const equ_name = this.$route.query.equ_name;
      console.log("从AllEquTable传过来的设备ID值为：",equ_id)
      console.log("从AllEquTable传过来的设备ID值为：",company)
      console.log("从AllEquTable传过来的设备ID值为：",equ_name)
      axios.get('/otherApi/get_equ_mess',{
        params:{
          equ_id : equ_id,
          days: 3
        }
      }).then(res => {
        this.option.title.text = company+equ_name;
        console.log("━━╋══════➢ ━$══➢ ━⊱══➢",res)
        const data = res.data.data;
        // 提取xAxis的数据
        const xAxisData = data.map(item => item.time);
        this.option.xAxis.data = xAxisData;
// 提取电表读数数据
//         const eImpEpData = data.map(item => item.E_ImpEp);
//         this.option.series.find(series => series.name === '电表读数').data = eImpEpData;

        // 提取功率数据
        const ePtData = data.map(item => item.E_pt);
        this.option.series.find(series => series.name === '功率').data = ePtData;

        // 提取箱体温度数据
        const rtuBoxTempData = data.map(item => item.RTU_box_temp);
        this.option.series.find(series => series.name === '箱体温度').data = rtuBoxTempData;

        // 提取回水温度数据
        const rtuWaterReturnTData = data.map(item => item.RTU_water_return_t);
        this.option.series.find(series => series.name === '回水温度').data = rtuWaterReturnTData;

        // 提取供水温度数据
        const rtuWaterSupplyTData = data.map(item => item.RTU_water_supply_t);
        this.option.series.find(series => series.name === '供水温度').data = rtuWaterSupplyTData;

        // 提取节能率数据（假设数据中有对应的字段，这里暂未看到，可根据实际情况修改）
        // const realtimeEsData = data.map(item => item.realtime_es);
        // this.option.series.find(series => series.name === '节能率').data = realtimeEsData;

        // 提取实时频率数据
        const vfdRealfeqData = data.map(item => item.vfd_realfeq);
        this.option.series.find(series => series.name === '实时频率').data = vfdRealfeqData;

        // 更新图表
        const chartDom = document.getElementById('main');
        const myChart = echarts.init(chartDom);
        if (this.option) {
          myChart.setOption(this.option);
        }
      })
        .catch(error => {
          console.error('Error fetching company id:', error);
        });
    },
  }
}
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 520px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/EnergyThree.vue